import {Box, Grid} from '@mantine/core';
import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import NumericInput from 'ui-library/inputs/NumericInput';
import {NumericInputChangeEvent} from 'util/Types';

import {DilutionSettings as DilutionSettingsType} from '../concentration-layers/machine/ConcentrationLayerMachine';
import PatternAssignmentIntegerInput from '../pattern-controls/PatternAssignmentIntegerInput';
import PatternDirectionDropdown from '../pattern-controls/PatternDirectionDropdown';

interface DilutionSettingsProps {
  dilutionSettings: DilutionSettingsType;
  onUpdateLayerDilutionSettings: (settings: Partial<DilutionSettingsType>) => void;
}

export default function DilutionSettings({
  dilutionSettings,
  onUpdateLayerDilutionSettings,
}: DilutionSettingsProps): JSX.Element {
  const {dilutionFactor, dilutionDirection, replicates, replicateDirection} = dilutionSettings;
  return (
    <Box>
      <Grid>
        <Grid.Col
          span={6}
          {...getTestProps({component: 'ConcentrationSettings', element: 'dilutionFactorInput'})}
        >
          <FieldLabel label="Dilution factor" isRequired={true} />
          <NumericInput
            value={dilutionFactor}
            min={0}
            onChange={(e: NumericInputChangeEvent) => {
              onUpdateLayerDilutionSettings({
                dilutionFactor: e.target.numericValue,
              });
            }}
            isDisabled={false}
            required={false}
            validateInteger={false}
          />
        </Grid.Col>

        <Grid.Col span={6}>
          <PatternDirectionDropdown
            label="Dilution direction"
            selectedDirection={dilutionDirection}
            onSelectDirection={(direction) => {
              onUpdateLayerDilutionSettings({
                dilutionDirection: direction,
              });
            }}
          />
        </Grid.Col>
      </Grid>

      <Grid>
        <Grid.Col
          span={6}
          {...getTestProps({component: 'ConcentrationSettings', element: 'replicatesInput'})}
        >
          <PatternAssignmentIntegerInput
            label="Replicates"
            isRequired={true}
            value={replicates}
            onChange={(value) => {
              onUpdateLayerDilutionSettings({
                replicates: value,
              });
            }}
          />
        </Grid.Col>

        <Grid.Col span={6}>
          <PatternDirectionDropdown
            label="Replicate direction"
            selectedDirection={replicateDirection}
            onSelectDirection={(replicateDirection) => {
              onUpdateLayerDilutionSettings({
                replicateDirection,
              });
            }}
          />
        </Grid.Col>
      </Grid>
    </Box>
  );
}
